import React from 'react'
import { Card } from './Card'
import { SkeletonBlock } from './SkeletonBlock'

export const SkeletonCard: React.FC<{ style?: React.CSSProperties }> = ({ style }) => (
  <Card padding="1.25rem" style={{ marginBottom: '0.75rem', ...style }}>
    <SkeletonBlock height="20px" width="80%" style={{ marginBottom: '0.75rem' }} />
    <SkeletonBlock height="14px" width="60%" style={{ marginBottom: '0.75rem' }} delay={0.05} />
    <SkeletonBlock height="14px" width="100%" style={{ marginBottom: '0.75rem' }} delay={0.1} />
    <SkeletonBlock height="14px" width="40%" delay={0.15} />
  </Card>
)
